import React from 'react';
import { useHistory } from 'react-router-dom';
import {
    shopRegionLabel,
    shopRegionSwitcherOptions,
    shopRegionWalkHint,
    shopRegionWalkHref,
} from './jobsSurface';

const RegionWalkSwitcher = ({ regionId, search = '', jobStatus }) => {
    const history = useHistory();
    const options = shopRegionSwitcherOptions(regionId);
    const regionLabel = shopRegionLabel(regionId, options);
    return (
        <label className="shop-region-switcher" data-testid="shop-region-switcher">
            Region
            <select
                aria-label="Shop jobs region"
                value={regionId}
                onChange={(event) => {
                    const next = event.target.value;
                    if (!next || next === regionId) return;
                    history.push(shopRegionWalkHref(next, search, jobStatus));
                }}
            >
                {options.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.label} · {option.id}
                    </option>
                ))}
            </select>
            <small>{shopRegionWalkHint(regionLabel, regionId)}</small>
        </label>
    );
};

export default RegionWalkSwitcher;
